import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StatusContractState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: StatusContractState = {
  data: [],
  isLoading: false,
  error: null,
};

const statusContractSlice = createSlice({
  name: 'statusContract',
  initialState,
  reducers: {
    setStatusContractes: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setStatusContractLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatusContractError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setStatusContractes, setStatusContractLoading, setStatusContractError } = statusContractSlice.actions;

export default statusContractSlice.reducer;
